import React, { Fragment } from 'react';
import { hot } from 'react-hot-loader/root';

import Routes from './routes/routes';

import './index.css';

const { REACT_APP_VERSION, NODE_ENV } = process.env;

const App = () => (
  <Fragment>
    <div className="appVersion">{REACT_APP_VERSION}</div>
    <Routes />
  </Fragment>
);

export default NODE_ENV === 'development' ? hot(App) : App;
